import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().email('msg_error_invalid_email_format').required('msg_email_required'),
  password: Yup.string().required('msg_password_required'),
});
